export default __webpack_public_path__ + "static/media/SultánOn.4391167b.png";